export const defaultLanguageCode = 'en_gb';
export const TENANT_SLANG_SUFFIX = '-x-';

export const getTenantLanguage = (langCode: string, suffix: string) => {
  return `${langCode}-${suffix}`;
};
